import { createFileRoute } from '@tanstack/react-router'
import { PublicReportPage } from '@/features/interviews/components/public-report-page'

export const Route = createFileRoute('/r/$shareToken')({
  component: PublicReportPage,
})
